const isBrowserNotificationSupported = (): boolean =>
  typeof window !== "undefined" && "Notification" in window;

export const requestDesktopNotificationPermission = (): void => {
  if (!isBrowserNotificationSupported()) return;

  try {
    if (Notification.permission === "default") {
      void Notification.requestPermission().catch(() => undefined);
    }
  } catch {
    // Safari iOS : l'API n'existe que pour les PWA ajoutées à l'écran d'accueil
  }
};

export const showDesktopNotification = (
  title: string,
  options?: NotificationOptions
): void => {
  if (!isBrowserNotificationSupported()) return;

  try {
    if (Notification.permission === "granted") {
      new Notification(title, options);
      return;
    }

    if (Notification.permission !== "denied") {
      void Notification.requestPermission()
        .then((permission) => {
          if (permission === "granted") {
            new Notification(title, options);
          }
        })
        .catch(() => undefined);
    }
  } catch {
    // Notification API absente ou bloquée (Safari iOS hors PWA)
  }
};
